import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../auth/session';

/** Gate a route behind a valid session; optionally require the admin role. */
export default function Protected(props: { children: React.ReactNode; admin?: boolean }) {
  const session = useSession();
  const loc = useLocation();

  if (!session) {
    const to = props.admin ? '/admin/login' : '/signin';
    return <Navigate to={to} state={{ from: loc.pathname + loc.search }} replace />;
  }
  if (props.admin && session.role !== 'admin') {
    return (
      <div className="app pad center">
        <h1>Admins only</h1>
        <p className="muted">Signed in as {session.operatorName} (operator).</p>
      </div>
    );
  }
  return <>{props.children}</>;
}
